module.exports = __webpack_public_path__ + "static/media/indexBorder.e1a9b27c.png";